<template>
  <v-container>
        <v-container fluid>
            <v-row align="start" justify="center">
                <span>
                    <h1>Blog</h1>
                </span>
            </v-row>
            <v-row>
                <v-col md="4" sm="12" xs="12" v-for="entrada in entradas" :key="entrada.Key" >
                <v-card @click="consultar">
                    <v-img src="../../public/img/logo Wall Audit.png"></v-img>
                    <v-card-title>
                        <span> 
                            {{entrada.Titulo}}
                        </span>
                    </v-card-title>
                    <v-card-subtitle>
                        Escrito por {{entrada.Autor}}
                        Tags: {{entrada.Tag}} 
                        <!--Wall Audit es una empresa dedicada a las tecnologías de la información, resolviendo e innovando todo tipo de servicios.-->
                    </v-card-subtitle>
                </v-card>
            </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import axios from 'axios'
export default {
    async created(){
        var peticion = await axios.get('https://wallaudit.com/api/getEntradas')
        this.entradas = peticion.data
        console.log(this.entradas)
        console.log("Eres un pendejo we")
    },
    data: () => ({
        entradas: null
    }),
    methods: {
        consultar(){
            
        }
    }
}
</script>

<style>

</style>